import { useAgentAuth } from '../../../contexts/AgentAuthContext';
import { useAgentToolUsage } from '../../../hooks/useAgentToolUsage';
import { TOOL_IDS } from '../../../lib/agents/firestore-schema';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';

export default function InvestmentComparison() {
  const { agentProfile } = useAgentAuth();
  useAgentToolUsage(agentProfile, TOOL_IDS.INVESTMENT_COMPARISON);

  return (
    <div>
      <h1 className="text-2xl font-semibold text-foreground mb-2">Investment Comparison</h1>
      <p className="text-muted-foreground mb-6">
        Compare different investment strategies. This tool will be implemented with inputs and comparison charts.
      </p>
      <Card>
        <CardHeader>
          <CardTitle>Coming soon</CardTitle>
          <CardContent>
            <p className="text-sm text-muted-foreground">
              You can add strategy parameters (e.g. lump sum vs DCA, risk levels) and see side-by-side projections and charts.
            </p>
          </CardContent>
        </CardHeader>
      </Card>
    </div>
  );
}
